import React, { useState, useCallback } from "react";
import BC365Service from "../../services/beautyclub365";
import { useUserContext } from "../../context/UserContext";
import "./Promocode.css";
import { YM_KEY } from "../../shared/constants";

const Promocode = ({
	tariff
}) => {

	const {
		userProfile,
		basketData,
		setBasket,
	} = useUserContext();

	const [coupon, setCoupon] = useState('');
	const [statusButton, setStatusButton] = useState({
		default: true,
		waiting: false,
		done: false,
	});
	const [error, setError] = useState('');

	const getTextButtonByStatus = useCallback(() => {
		if (statusButton['waiting']) {
			return 'Подождите';
		}
		if (statusButton['done']) {
			return 'Активирован';
		}
		return 'Применить';
	}, [
		statusButton,
	]);

	const isActiveClass = useCallback(() => {
		if (statusButton['default']) {
			return 'promoButton';
		}
		return 'promoButton notActive';
	}, [
		statusButton,
	]);

	const writeCoupon = (e) => {
		setCoupon(e.target.value);
		setError('');
	};

	const getDiscount = useCallback((e) => {
		if (!statusButton.default) return;
		const db = new BC365Service();
		const { product_id } = basketData;
		const { user_id } = userProfile;
		setStatusButton({
			default: false,
			waiting: true,
			done: false,
		});
		db.getDiscount(e, product_id, user_id).then((answer) => {
			if (answer.discount > 0) {
				ym(YM_KEY, 'reachGoal', 'lead_promocode');

				const priceAfterDiscount = answer.base_price - answer.discount;
				const formattedPrice = new Intl.NumberFormat('ru-RU', { currency: 'RUB' }).format(priceAfterDiscount);
				const formattedOriginalPrice = new Intl.NumberFormat('ru-RU', { currency: 'RUB' }).format(answer.base_price);
				setBasket({
					...basketData,
					price_clear: priceAfterDiscount,
					price: `${formattedPrice} руб.`,
					original_price: `${formattedOriginalPrice} руб.`,
				});
				setStatusButton({
					default: false,
					waiting: false,
					done: true,
				});
			} else {
				setError('Промокод не найден или не дает скидку');
				setStatusButton({
					default: true,
					waiting: false,
					done: false,
				});
			}
		});
	}, [
		coupon,
		statusButton,
		basketData,
		userProfile,
	]);

	return (
		<>
			<div className="promoWrapper">
				<input id="promo" type="text" placeholder="Введите промокод" className="promoInput" onChange={writeCoupon} />
				<span className={isActiveClass()} onClick={() => getDiscount(coupon.trim())}>{getTextButtonByStatus()}</span>
			</div>
			{error && <div className="promoError">{error}</div>}
			<div className="cpWrapper2">
				<span className="cpPrice">К оплате {basketData.price}</span>
				{basketData.original_price && basketData.original_price !== basketData.price && (
					<span className="cpOriginalPrice">{basketData.original_price}</span>
				)}
				<span className="cpTarriff"> Тариф {tariff}</span>
			</div>
		</>
	);
};

export default Promocode;